/* eslint-disable react/no-access-state-in-setstate */
import { Row, Col } from '@vds/grids';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { reduxForm } from 'redux-form/immutable';
// import DayPicker from 'react-day-picker';
import parse from 'html-react-parser';
import CheckBox from '../../common/CheckBox/index';
import Button from '../../common/Button/index';
import Notification from '../../common/Notification/index';
import { goToProcessStep } from '../../../redirection';
import { Title, Body } from '../../common/Typography/index';
import TextLink from '../../common/TextLink';
import { getSession, getIntendType, viewport, getAPPID, isPreorder } from '../../common/Helpers/index';
import CalenderVds from '../../common/Calender/index';
// import { Calendar } from '@vds/inputs';

import { getTwoDigitMonthNonUTC, getTwoDigitDateNonUTC } from '../../../utils/CalenderUtils';
// import Button from '../common/Button';
import { mvaLinkApiCall } from '../../common/MVAApiCall';
import { getItemFromStore } from '../../../utils/sessionStorage';

class SelfAppointmentSchedule extends Component {
  static propTypes = {
    // cqContent: PropTypes.object,
    // schedulingDetails: PropTypes.object,
    // isFCLFlow: PropTypes.bool,
    currentView: PropTypes.string,
    history: PropTypes.string,
    covidImportant: PropTypes.string,
    mva_covidImportant: PropTypes.string,
    mva_learnMoreUrl: PropTypes.string,
    postSelfInstallation: PropTypes.func,
    appointmentScheduleState: PropTypes.object,
    cartDetails: PropTypes.object,
    selfCancellationHead: PropTypes.string,
    selfCancellationSubHead: PropTypes.string,
    policy: PropTypes.string,
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    targetHeading: PropTypes.string,
    targetSubHeading: PropTypes.string,
    importantHeading: PropTypes.string,
    saveSelfInstallDate: PropTypes.object,
    api_fail_text: PropTypes.string,
  };

  constructor(props) {
    super(props);
    // this.completeOrder = this.completeOrder.bind(this);
    this.state = {
      selectedDay: null,
      isAgreementChecked: false,
      selectedDate: null,
      enableSubmitCTA: true,
    };
  }

  // handleMonthClick() {
  //   this.setState({
  //     isSlotsVisible: false,
  //     isSlotSelected: false,
  //     selectedDay: null,
  //     showOutOfTimeFrame: true,
  //     datesUpdated: false,
  //   });
  // }

  // handleReminder = (reminderType) => {
  //   this.setState({
  //     reminderType,
  //     isFieldVisible: true,
  //     isReminderVisible: true,
  //     // isReminderChoosen: true,
  //     showSpecialInstruction: true,
  //     showButton: true,
  //     submitting: isValidEmail(this.state.emailValue) && isValidNANPPhoneNumber(this.state.phoneNumberValue) ? true : false, //eslint-disable-line
  //   });
  // }

  componentDidMount() {
    this.accessibilityInit(true);
  }

  componentWillUnmount() {
    this.accessibilityInit(false);
  }

  redirection = () => {
    if (getAPPID() === 'NSE') {
      goToProcessStep(this.props.currentView.NSE, this.props.history);
    } else {
      goToProcessStep(this.props.currentView, this.props.history);
    }
  };

  accessibilityInit = (mount) => {
    const monthYearCaption = document.querySelector('.DayPicker-Caption >div');
    const prevMonthArrow = document.querySelector('.DayPicker-NavButton--prev');
    const nextMonthArrow = document.querySelector('.DayPicker-NavButton--next');
    const currentTime = new Date();
    const currentMonth = currentTime.toLocaleString('default', { month: 'long' });
    const currentYear = currentTime.getFullYear();
    const onFocusEventHandler = (event) => {
      monthYearCaption.setAttribute('aria-label', event.target.innerText);
    };

    if (mount && monthYearCaption) {
      monthYearCaption.setAttribute('tabindex', 0);
      monthYearCaption.setAttribute('role', 'label');
      monthYearCaption.setAttribute('aria-label', monthYearCaption.innerText);
      nextMonthArrow.setAttribute('aria-label', `next month ${currentMonth} ${currentYear}`);
      prevMonthArrow.setAttribute('aria-label', `previous month ${monthYearCaption.innerText}`);
      monthYearCaption.addEventListener('focus', onFocusEventHandler);
    } else if (monthYearCaption && monthYearCaption.removeEventListener) {
      monthYearCaption.removeEventListener('focus', onFocusEventHandler, true);
    }
  };

  onSubmitOrder = () => {
    //   alert(this.state.selectedDay);
    //   alert(new Date(this.state.selectedDay));
    const orderSubmitted = getSession('OrderSubmitted');
    if (getAPPID() === 'NSE' && orderSubmitted === 'Y') {
      goToProcessStep(this.props.currentView.NSE, this.props.history);
    } else if (orderSubmitted === 'Y') {
      goToProcessStep(this.props.currentView, this.props.history);
    }

    const data = {
      accountNumber: '',
      cartCreator: '',
      processingMTN: 'newLine1',
      processStep: 'AppointmentSchedule',
      processAction: 'updateSelfInstallDate',
      intendType: `${getIntendType()}`,
      cartLineMtn: 'newLine1',
      selectedDate: this.state.selectedDate,
    };
    this.props.saveSelfInstallDate(this.state.selectedDate);
    return this.props.postSelfInstallation(data);
  };

  // onSubmitOrderSuccess = () => {
  //   let validatePromise = this.props.callSubmitOrder("");
  //   Promise.all([validatePromise])
  //     .then(
  //       this.completeOrder()
  //     ).catch()
  //   // this.setState({ enableSubmitCTA: false });
  //   // this.completeOrder();
  // }

  handleClick = () => {
    this.setState({ isAgreementChecked: !this.state.isAgreementChecked });
  };

  learnMoreClick = (e, learnMoreLink) => {
    e.preventDefault();
    mvaLinkApiCall(learnMoreLink);
  };

  handleDayMouseEnter = (day, modifiers = {}) => {
    if (modifiers.disabled || modifiers.selected) {
      // return;
    }
    // const selectedDate = `${getDay(day.getUTCDay())}, ${getMonth(day.getUTCMonth())} ${day.getUTCDate()}, ${day.getUTCFullYear()}`;
    // const dateString = `${day.getUTCFullYear()}${getTwoDigitMonth(day)}${getTwoDigitDate(day)}`;
    // this.setState({
    //   // selectedDay: null,
    //   hoverDay: day,
    //   hoveredCustomizedDate: selectedDate,
    // });
  };

  // completeOrder = () => {
  //   //alert(this.state.selectedDate.getFullYear()+this.state.selectedDate.getMonth()+1+this.state.selectedDate.getDate())

  //   goToProcessStep(this.props.currentView, this.props.history);
  // }

  handleDayClick = (day, modifiers = {}) => {
    if (modifiers.disabled || modifiers.selected) {
      return;
    }
    // debugger;
    // const dummy = day.getUTCDate();
    // const dummy1 = day.getDate();
    // const selectedDate = `${getDay(day.getUTCDay())}, ${getMonth(day.getUTCMonth())} ${day.getUTCDate()}, ${day.getUTCFullYear()}`;
    const dateString = `${day.getUTCFullYear()}${getTwoDigitMonthNonUTC(day)}${getTwoDigitDateNonUTC(day)}`;
    // alert(dateString)
    this.setState({
      // hoverDay: null,
      selectedDay: modifiers.selected ? undefined : day,
      // selectedCustomizedDate: modifiers.selected ? undefined : selectedDate,
      selectedDate: dateString,
      // showOutOfTimeFrame: false,
    });
  };

  handleDayMouseLeave = (modifiers) => {
    if (modifiers.disabled || modifiers.selected) {
      // return;
    }
    // this.setState({
    //   hoverDay: null,
    //   hoveredCustomizedDate: null,
    // });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.appointmentScheduleState.isSubmitSuccess !== nextProps.appointmentScheduleState.isSubmitSuccess) {
      // alert(this.props.deviceSetupState.selectedOption);
      this.redirection();
    }
  }

  render() {
    // const { isSubmitSuccess } = this.props.appointmentScheduleState;
    const type = viewport();
    // if (type === 'mfapp') {
    //   // debugger;
    //   const isSubmitted = getSession('isSubmitted');
    //   if (isSubmitted === 'Y') {
    //     goToProcessStep(this.props.currentView, this.props.history);
    //   }
    // }
    // if (getAPPID() === 'NSE' && isSubmitSuccess) {
    //   goToProcessStep(this.props.currentView.NSE, this.props.history);
    // } else if (isSubmitSuccess) {
    //   goToProcessStep(this.props.currentView, this.props.history);
    // }

    // const startDate = this.props.cartDetails?.shippingDetails?.[0].deliveryDate || getSession('deliveryDate');
    let startDate = this.props.cartDetails?.shippingDetails?.[0].deliveryDate || getItemFromStore('deliveryDate');
    if (isPreorder()) {
      startDate = this.props.cartDetails?.orderDetailsView?.preOrderInServiceDate;
    }
    // debugger;
    // if(startDate.includes('NaN')){
    //   const deliveryDate = new Date();
    //   const deliveryDate1 = deliveryDate.getMonth() + 1 + '/' + deliveryDate.getDate() + '/' + deliveryDate.getFullYear();
    //   setCookie('deliveryDate', deliveryDate1);
    // }
    // alert(startDate)
    // debugger;
    const startDateFormat = new Date(startDate);
    // alert(startDateFormat);
    // alert(startDateFormat.getFullYear())
    const endDate = new Date(startDate);
    endDate.setDate(endDate.getDate() + 29);
    // alert(endDate)

    // const schedulingDetails = {
    //   startDate: startDateFormat,
    //   endDate: endDate
    // };
    // alert(this.state.selectedDay)
    // const WEEKDAYS_SHORT = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    const disabledDays = [
      {
        before: new Date(startDateFormat.getFullYear(), startDateFormat.getMonth(), startDateFormat.getDate()),
        after: new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate()),
      },
    ];
    const show = getItemFromStore('show');
    const errorState = this.props.appointmentScheduleState.errorSubmit;
    let showError = false;
    if (show === 'false') {
      showError = false;
    } else if (errorState && show === 'true') {
      showError = true;
    }
    // const dataTrackObj = '{"type" : "input", "name" : "appointmentSchedule", "state" :"$stateVari"}'.replace('$stateVari', this.state.isAgreementChecked ? 'checked' : 'Unchecked');
    const { covidImportant, mva_covidImportant, mva_learnMoreUrl } = this.props;
    let importantText =
      covidImportant ||
      "In response to the current and continued impact of coronavirus (COVID-19), we are taking the appropriate steps consistent with public health recommendations to safeguard our customers and employees. <br/> If you have current service with another provider, do not disconnect that service until you have established your new Verizon service and validated it is working. For Self Setup customers, support will be available through the My Verizon App & My Verizon Online. Customers with questions about Verizon's COVID-19 preparedness strategy can <a target='_blank' href='https://www.verizon.com/about/news/covid-response-customers' style='color:#000;font-size:12px;'>learn more here.</a>";
    if (type === 'mfapp') {
      importantText =
        mva_covidImportant ||
        "In response to the current and continued impact of coronavirus (COVID-19), we are taking the appropriate steps consistent with public health recommendations to safeguard our customers and employees. <br/> If you have current service with another provider, do not disconnect that service until you have established your new Verizon service and validated it is working. For Self Setup customers, support will be available through the My Verizon App & My Verizon Online. Customers with questions about Verizon's COVID-19 preparedness strategy can ";
    }
    const leranMoreUrl = mva_learnMoreUrl || 'https://www.verizon.com/about/news/covid-response-customers';
    // debugger;
    return (
      <React.Fragment>
        {/* {this.props.appointmentScheduleState?.orderSubmitResponse?.errors && (
        <Col className="errorBanner" colSizes={{ mobile: 12, tablet: 6, desktop: 6 }}>
          <Notification
            type="warning"
            title={this.props.api_fail_text ? this.props.api_fail_text : 'Something went wrong, please try again.'}
            subtitle=""
          />
        </Col>
        )} */}
        {this.props.appointmentScheduleState?.orderSubmitResponse?.errors && (
          <Col xs={8} lg={12} md={12}>
            <Notification
              type="warning"
              title={this.props.api_fail_text ? this.props.api_fail_text : 'Something went wrong, please try again.'}
              subtitle=""
            />
          </Col>
        )}

        <Col xs={12} className="noPadding">
          <Row className="margin18 noSideMargin noBottomMargin">
            <Col xs={8} lg={6} md={12} className="border_black onlyBottomBorder borderSize_4 appointmentHeader">
              <Row className={type === 'mfapp' ? 'pad30 onlyBottomPad marginTop50' : 'pad30 onlyBottomPad'}>
                <Title primitive="h1" size="large" bold>
                  {this.props.heading}
                </Title>
                <div className="margin6 noSideMargin">
                  <Body className="paddingTop8" primitive="p" size="large">
                    {this.props.subHeading}
                  </Body>
                </div>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={5} md={12}>
              <Row>
                <Col xs={9}>
                  <div className="margin8 onlyTopMargin subHeading_calender">
                    <Title primitive="h2" size="small" bold>
                      {this.props.targetHeading}
                    </Title>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <div>
                    <Body primitive="p" size="small">
                      {this.props.targetSubHeading}
                    </Body>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={9} md={12} style={{ zIndex: '1' }} className="marginTop10">
              {/* <AppointmentCalender
                      cqContent={cqContent}
                      schedulingDetails={schedulingDetails}
                      selectedDay={this.state.selectedDay}
                      handleDayClick={this.handleDayClick}
                      handleMonthClick={this.handleMonthClick}
                      disableDates={this.state.showOutOfTimeFrame}
                      handleDayMouseEnter={this.handleDayMouseEnter}
                      handleDayMouseLeave={this.handleDayMouseLeave}
                      /> */}

              {/* <DayPicker
                onDayClick={this.handleDayClick}
                fromDate={new Date(startDateFormat.getFullYear(), startDateFormat.getMonth(), startDateFormat.getDate())}
                toDate={new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate())}
                // onMonthChange={this.handleMonthClick}
                fromMonth={new Date(startDateFormat.getFullYear(), startDateFormat.getMonth(), startDateFormat.getDate())}
                toMonth={new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate())}
                month={new Date(startDateFormat.getFullYear(), startDateFormat.getMonth(), startDateFormat.getDate())}
                weekdaysShort={WEEKDAYS_SHORT}
                selectedDays={this.state.selectedDay}
                // month={schedulingDetails.startDate && new Date(getDateYear(schedulingDetails.startDate), getDateMonth(schedulingDetails.startDate))}
                // onDayMouseEnter={this.handleDayMouseEnter}
                // onDayMouseLeave={this.handleDayMouseLeave}
                analyticstrack="5g-schedule-appointment"
                disabledDays={disabledDays}

              /> */}
              <CalenderVds
                minDate={new Date(startDateFormat.getFullYear(), startDateFormat.getMonth(), startDateFormat.getDate())}
                inactiveDates={disabledDays}
                maxDate={new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate())}
                onChange={this.handleDayClick}
                // activeStartDate={new Date(startDateFormat.getFullYear(), startDateFormat.getMonth(), startDateFormat.getDate())}
                selectedDate={null}
              />
            </Col>
          </Row>
          <Row className="margin18 noSideMargin noBottomMargin">
            <Col xs={8} lg={6} md={12} className="border_black onlyTopBorder borderSize_4">
              <Row className="pad10 onlyBottomPad">
                <div className="width100 fontSize_2 margin8 onlyTopMargin subHeading_calender">
                  <Title className="paddingTop8" primitive="h2" size="small" bold>
                    {this.props.importantHeading}
                  </Title>

                  <span>
                    {' '}
                    <Body primitive="p" size="small">
                      {type === 'mfapp' ? (
                        <span>
                          {parse(importantText)}
                          <TextLink role="link" size="small" onClick={(e) => this.learnMoreClick(e, leranMoreUrl)} className="link">
                            learn more here.
                          </TextLink>
                        </span>
                      ) : (
                        parse(importantText)
                      )}
                    </Body>{' '}
                  </span>
                </div>
              </Row>
              <Row className="pad10 onlyBottomPad">
                <div className="width100 fontSize_2 margin8 onlyTopMargin subHeading_calender">
                  <Title className="paddingTop8" primitive="h2" size="small" bold>
                    {this.props.selfCancellationHead}
                  </Title>
                </div>
                <div className="margin6 noSideMargin noBottomMargin">
                  <Body primitive="p" size="small">
                    {this.props.selfCancellationSubHead}
                  </Body>
                </div>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col
              role="checkbox"
              xs={8}
              lg={12}
              md={12}
              className="width0 checkboxPadding"
              analyticstrack="agreement-policy"
              aria-checked={this.state.isAgreementChecked}
              style={{ display: 'inline-flex' }}
            >
              <CheckBox
                className="checkbox"
                name="agreementPolicyFlag"
                id="agreementPolicyFlag"
                // component="input"
                onChange={() => this.handleClick()}
                type="checkbox"
                ariaChecked={this.state.isAgreementChecked}
              >
                <Body primitive="p" size="small">
                  {this.props.policy}
                </Body>
              </CheckBox>
            </Col>
          </Row>
          {this.state.selectedDay && this.state.isAgreementChecked && (
            <Row>
              <Col xs={8} lg={6} md={6}>
                <Button
                  primary
                  size="large"
                  type="button"
                  className="margin30 noSideMargin width100"
                  analyticstrack="5G-scheduleAppointmentView"
                  tabIndex={this.state.tIndex}
                  onClick={() => this.onSubmitOrder()}
                  data-track
                  disabled={!this.state.enableSubmitCTA || showError}
                >
                  Complete Order
                </Button>
              </Col>
            </Row>
          )}
        </Col>
      </React.Fragment>
    );
  }
}

export default reduxForm({
  form: 'appointmentSchedule',
  //   validate,
  //   asyncValidate,
  asyncBlurFields: ['phoneDetails'],
  enableReinitialize: true,
  destroyOnUnmount: false,
})(SelfAppointmentSchedule);
